// extracted by mini-css-extract-plugin
export var active = "_bi-2";
export var container = "_bi-0";
export var expired = "_bi-3";
export var hasStatus = "_bi-4";
export var statusChip = "_bi-1";